import { SOGetDatafeed } from '../datafeed/so-get-datafeed';
import { SOGetOrganization } from '../organization/so-get-organization';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetAlertSubscription implements QueryProtocol {

  constructor(
    public uid: string = null,
    public datafeed: SOGetDatafeed = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetAlertSubscription(
      'uid' in params ? params.uid : null,
      'datafeed' in params ? params.datafeed : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
